import Types from "./types";
import { CarService } from "../../../service/car-service";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";

const saveSelectedCity = (selectedValue, selectedID) => ({
    type: Types.SAVE_SELECTED_CITY,
    selectedValue,
    selectedID
});

const getBranchesByIDSuccess = (branches) => ({
    type: Types.FETCH_BRANCHES_BY_ID_SUCCESS,
    branches
});

const getBranchesByIDFailure = () => ({
    type: Types.FETCH_BRANCHES_BY_ID_FAILURE
});

const getBranchesByCoordinatesFailure = () => ({
    type: Types.FETCH_BRANCHES_BY_COORDINATES_FAILURE
});

const getBranchesByCoordinatesSuccess = (branches) => ({
    type: Types.FETCH_BRANCHES_BY_COORDINATES_SUCCESS,
    branches
});

const getBranchesByCoordinates = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchGeoSlots(params).then(response => {
            if (response.zone) {
                const homeInspectionLocation = {
                    address1: response.slots[response.zone.location_id].address_detail.address1,
                    address2: response.slots[response.zone.location_id].address_detail.address2,
                    city_id: response.zone.city_id,
                    type: "locality",
                    location_id: response.zone.location_id,
                    location_name: response.slots[response.zone.location_id].location_name
                };
                response.locations.push(homeInspectionLocation);
            }
            dispatch(getBranchesByCoordinatesSuccess(response.locations));
            resolve(response.locations);
        }).catch(() => {
            dispatch(getBranchesByCoordinatesFailure());
            reject();
        });
    });
};

const getBranchesByID = (id) => dispatch => {
    return new Promise((resolve, reject) => {
        CarService.fetchBranchesByCityID(id).then(response => {
            const filteredList = response.locations.filter(item => item.type === "store");
            dispatch(getBranchesByIDSuccess(filteredList));
            resolve(response);
        }).catch(() => {
            dispatch(getBranchesByIDFailure());
            reject();
        });
    });
};

const setSelectionType = (selectionType) => ({
    type: Types.SET_SELECTION_TYPE,
    selectionType
});

const setSelectedBranch = (selectedBranch) => ({
    type: Types.SET_SELECTED_BRANCH,
    selectedBranch
});

const updateNearestBranchSearchKey = () => ({
    type: Types.GENERATE_SEARCH_IDENTIFIER_KEY
});

export {
    getBranchesByID,
    getBranchesByCoordinates,
    saveSelectedCity,
    setSelectionType,
    setSelectedBranch,
    updateNearestBranchSearchKey
};
